import React from 'react';
import './PerformanceChart.css';

const PerformanceChart: React.FC = () => {
  return (
    <div className="performance-chart">
      <div className="chart-canvas">
        <div className="chart-line"></div>
      </div>
    </div>
  );
};

export default PerformanceChart;
